<template>
  <HeaderView/>
  <hr>
  <router-view/>
  <FooterView/>
</template>

<script>
import HeaderView from './layouts/HeaderView.vue'
import FooterView from './layouts/FooterView.vue'

export default {
  components: {HeaderView, FooterView},
  data() {
    return {
    }
  },
}
</script>


<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

nav {
  padding: 30px;
}

nav a {
  font-weight: bold;
  color: #2c3e50;
}

nav a.router-link-exact-active {
  color: #42b983;
}
</style>
